import React from 'react';
import { useParams } from 'react-router-dom';

function CreatorProfile() {
  const { id } = useParams();

  const creator = {
    id,
    name: id.replace(/-/g, ' ').replace(/\b\w/g, c => c.toUpperCase()),
    gifts: [
      { id: 1, title: "Lingerie Set", price: "$75" },
      { id: 2, title: "Crypto Tip", price: "$100" },
    ],
  };

  return (
    <div className="profile-container">
      <h2>{creator.name}'s Shop</h2>
      <ul className="gift-list">
        {creator.gifts.map((gift) => (
          <li key={gift.id}>
            <strong>{gift.title}</strong> — {gift.price}
            <button className="send-btn">Send</button>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default CreatorProfile;
